import { render, staticRenderFns } from "./ExpirationCounter.vue?vue&type=template&id=1e2312c1&"
import script from "./ExpirationCounter.vue?vue&type=script&lang=js&"
export * from "./ExpirationCounter.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationCounter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports